<form [formGroup]="formGroup">
    <sc-sub-title>
      <sc-dictionary-label dictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.title"></sc-dictionary-label>
    </sc-sub-title>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-string-field formControlName="reason" labelDictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.details.reason">
    </sc-string-field>

    <sc-content-spacer vertical></sc-content-spacer>

    <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.details.notes"></sc-dictionary-label>
        </mat-label>
        <textarea formControlName="note" matInput name="notes" cdkTextareaAutosize cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="8"></textarea>
    </mat-form-field>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-flex >
        <sc-string-field grow formControlName="name" labelDictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.name">
        </sc-string-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-string-field grow formControlName="department" labelDictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.department">
        </sc-string-field>
    </sc-flex>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-flex >
        <sc-string-field grow formControlName="phone" labelDictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.phone">
        </sc-string-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-string-field grow formControlName="mail" labelDictionaryKey="tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.mail">
        </sc-string-field>
    </sc-flex>

</form>
